import React from 'react';

const LoadingIndicator = () => {
    return (
        <div className="loading-indicator">
            The assistant is typing...
            <div className="spinner"></div>
        </div>
    );
};

export default LoadingIndicator;